<template>
  <div class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      class="tabs__btn"
      :class="{ 'tabs__btn--active': value === tab.key }"
      @click="$emit('update:value', tab.key)"
      type="button"
    >
      <span class="tabs__label">{{ tab.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { ShopCategory } from "../shared/shopTypes"
import { CATEGORY_LABEL } from "../shared/shopTypes"

defineProps<{
  value: ShopCategory
}>()
defineEmits<{
  "update:value": [v: ShopCategory]
}>()

const categories: ShopCategory[] = ["room", "hats", "accessories", "outfits", "pets"]
const tabs = categories.map((key) => ({
  key,
  label: CATEGORY_LABEL[key],
}))
</script>

<style scoped>
.tabs {
  display: flex;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  padding-bottom: 2px;
  scrollbar-width: none;
}
.tabs::-webkit-scrollbar { display: none; }
.tabs__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 13px;
  border-radius: 10px;
  border: 2px solid transparent;
  background: #F6F2E9;
  color: #666873;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  justify-content: center;
  min-height: 44px;
  font-family: "Inter", system-ui, sans-serif;
  transition: all 0.15s;
  flex: 0 0 auto;
  white-space: nowrap;
}
@media (min-width: 600px) {
  .tabs__btn { flex: 1; }
}
.tabs__btn:hover {
  background: #E8E5F4;
  color: #6258D9;
}
.tabs__btn--active {
  background: #6258D9;
  color: #fff;
  box-shadow: 0 4px 12px rgba(98, 88, 217, 0.3);
}
.tabs__icon {
  font-size: 16px;
}
</style>
